import React, { useEffect, useState } from 'react';
import { Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import useUserProfile from '../../useUserProfile';

const API_URL = process.env.REACT_APP_API_URL;

const UploadUnitManagerBudgetMonthly: React.FC = () => {
  const [fileList, setFileList] = useState<any[]>([]);
  const { instance,accounts } = useMsal();
  const { requestProfileData } = useUserProfile();
  const [UserDetails, setUserDetails] = useState<{ id:string , displayName: string, email: string }[]>([]);
  

  const fetchToken = async () => {
    const res = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0]
    });
    return res.idToken;
  };

    useEffect(() => {
      const fetchProfileData = async () => {
        try {
          await requestProfileData();
          const userMail = localStorage.getItem("UserMail");
          const userName = localStorage.getItem("UserName");
          const userId = localStorage.getItem("UserId");
          setUserDetails([{ id: userId || '', displayName: userName || 'Default Nominator', email: userMail || '' }]);
  
        } catch (error) {
          console.error('Error fetching profile data:', error);
        }
      };
    
      fetchProfileData();
    }, [requestProfileData]);


const handleUpload = async () => {
    if (fileList.length === 0) {
      message.error('Please select a file to upload');
      return;
    }
    if (!UserDetails.length || !UserDetails[0]?.id) {
      message.error('User details are not yet loaded. Please try again later.');
      return;
    }
    const file = fileList[0];
    const reader = new FileReader();
    reader.onload = async (e) => {
      if (!e.target) {
        message.error('Error reading file');
        return;
      }
      const userid=UserDetails[0].id;
      const data = new Uint8Array(e.target.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { raw: false });
  
      // Map jsonData to the expected format and validate required fields
      const mappedData = jsonData.map((item: any) => ({
        EmployeeNumber: item.Unit_Head_Employee_Number || '',
        AwardsCount: item.Total_Awards_Eligible_For || 0,
        Span: item.Total_Span || 0,
        Comments: item.Comments || '',
      }));
      // Check for missing required fields
      const invalidItems = mappedData.filter(item => !item.EmployeeNumber);
      if (invalidItems.length > 0) {
        message.error('Please ensure all required fields are filled in the Excel file.');
        return;
      }
  
      try {
        const token = await fetchToken(); 
        const response = await axios.post(
          `${API_URL}/api/ManagerBudget/UnitManagerBudget`,

          {
            id: userid,
            data: mappedData, // Ensure data is correctly structured
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        );
        
        if (response.status === 200) {
          message.success('File uploaded successfully');
        } else {
          message.error('Failed to upload file');
        }
      } catch (error) {
        console.error('Error uploading file:', error);
        message.error('Error uploading file');
      }
    };
    reader.readAsArrayBuffer(file);
  };
  
const beforeUpload = (file: any) => {
    setFileList([file]);
    return false;
  };

  return (
    <div>
    <h4>Unit manager budget</h4>
      <Upload beforeUpload={beforeUpload} fileList={fileList}>
        <Button icon={<UploadOutlined />}>Select File</Button>
      </Upload>
      <Button
        type="primary"
        onClick={handleUpload}
        disabled={fileList.length === 0}
        style={{ marginTop: 16 }}
      >
        Upload
      </Button>
    </div>
  );
};

export default UploadUnitManagerBudgetMonthly;




